import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
// import "fullcalendar-reactwrapper/dist/css/fullcalendar.min.css";
import API from "../../actions";
import "./Calendar.css";
import PremiumMessage from "../Alerts/PremiumMessage.js";
import OpeningHours from "./OpeningHours.js";
import BigCalendar from "./BigCalendar.js";
import ColorCodes from "./ColorCodes.js";
import BookingCard from "./BookingCard.js";
import BookingDrawer from "./BookingDrawer.js";
import CourseCalendarCard from "./CourseCalendarCard.js";
import update from "immutability-helper";
import DeleteIcon from "@material-ui/icons/Delete";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@material-ui/core";
import moment from "moment";
import { format } from "date-fns";
import { useRef } from "react";
import EditBookingDrawer from "./EditBookingDrawer.js";

export default props => {
    const therapist = useSelector(state => state.data.therapist);

    const [step, setStep] = useState(0);
    const [openingHour, setOpeningHour] = useState(false);
    const [premiumAlert, setPremiumAlert] = useState(false);
    const [even, setEvent] = useState([]);
    const [bookingObject, setBookingObject] = useState({});
    const [dateInfo, setDateInfo] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [isEdit, setEdit] = useState(false);

    const calendarRef = useRef(null);
    const [currentViewDate, setCurrentViewDate] = useState(new Date(new Date().toISOString()));

    const handleDrop = useCallback(async dropInfo => {
        const booking = await API.getBooking(dropInfo.event.extendedProps.bookingId);

        const startDate = dropInfo.event.start; // native Date object
        const endDate = dropInfo.event.end; // native Date object

        const tzo = startDate.getTimezoneOffset();
        const updatedBooking = update(booking, {
            from: { $set: startDate.getTime() },
            to: { $set: endDate.getTime() }
        });

        await API.setBooking(updatedBooking);
    }, []);
    const handleDateClick = useCallback(e => {
        setDateInfo(e);
    }, []);
    const handleSetPremiumAlert = useCallback(e => {
        setPremiumAlert(e);
    }, []);
    const handleOpeningHour = useCallback(e => {
        setOpeningHour(e);
    }, []);
    // const handelEventClick = useCallback(async e => {
    //     console.log(e, "e--------");

    //     if (e.limit === undefined) {
    //         const b = await API.getBooking(e.bookingId);
    //         if (b) {
    //             if (!!!b.treatmentId) {
    //                 setHolidayInfo(b);
    //             } else {
    //                 setEvent(e);
    //                 setBookingObject(b);
    //                 setStep(1);
    //             }
    //         }
    //         return;
    //     }
    //     setEvent(e);
    //     setStep(2);
    //     return;
    // }, []);
    const handelEventClick = useCallback(async e => {
        const event = e.event;

        const eventProps = event.extendedProps;
        const start = event.start;
        const end = event.end;

        if (eventProps.limit === undefined) {
            const booking = await API.getBooking(eventProps.bookingId);

            if (booking) {
                if (!booking.treatmentId) {
                    setHolidayInfo({ ...booking, start, end }); // optionally include dates
                } else {
                    setEvent({ ...eventProps, start, end });
                    setBookingObject(booking);
                    setStep(1);
                }
            }
        } else {
            setEvent({ ...eventProps, start, end });
            setStep(2);
        }
    }, []);

    const handleClosePremium = (e, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setPremiumAlert(false);
    };

    const [holidayInfo, setHolidayInfo] = useState();
    const [holidayDelete, setHolidayDeleted] = useState(false);

    const handleEditBooking = async data => {
        try {
            const clientData = await API.getClient(data.clientId);
            const booking = await API.getBooking(data.bookingId);
            setDateInfo({ data, booking, clientData });
            setEdit(true);
            setStep(1);
        } catch (err) {
            console.error("Error fetching client data:", err);
        }
    };

    // console.log(calendarRef, "calendarRef");

    // useEffect(() => {
    //     console.log(currentViewDate, "currentViewDate");

    //     if (calendarRef.current && currentViewDate) {
    //         setTimeout(() => {
    //             const calendarApi = calendarRef.current.getApi();
    //             calendarApi.gotoDate(currentViewDate); // Restore selected view
    //         }, 200); // Delay to ensure calendar has been remounted
    //     }
    // }, [calendarRef, currentViewDate]);

    // useEffect(() => {
    //     if (calendarRef.current && props.currentViewDate) {
    //         const calendarApi = calendarRef.current.getApi();
    //         calendarApi.gotoDate(props.currentViewDate);
    //     }
    // }, [props.currentViewDate]);
    return (
        <>
            {
                <ShowHolidayDialog
                    open={!!holidayInfo}
                    onClose={() => {
                        setHolidayInfo(null);
                    }}
                    data={holidayInfo}
                    onDelete={() => {
                        setHolidayDeleted(!holidayDelete);
                    }}
                />
            }
            <div className="calendarContainer">
                <div id="example-component">
                    {step === 0 ? (
                        <BigCalendar
                            therapist={therapist}
                            setPremiumAlert={handleSetPremiumAlert}
                            setOpeningHour={handleOpeningHour}
                            handleDrop={handleDrop}
                            handleDateClick={handleDateClick}
                            handleEventClick={handelEventClick}
                            holidayDelete={holidayDelete}
                            calendarRef={calendarRef}
                            currentViewDate={currentViewDate}
                            setStartDate={setStartDate}
                            setCurrentViewDate={setCurrentViewDate}
                        />
                    ) : step === 1 ? (
                        <BookingCard
                            even={even}
                            booking={bookingObject}
                            therapist={therapist}
                            close={() => setStep(0)}
                            handleEditBooking={handleEditBooking}
                        />
                    ) : (
                        <CourseCalendarCard event={even} close={() => setStep(0)} />
                    )}
                </div>
                <ColorCodes />
                {isEdit && dateInfo ? (
                    <EditBookingDrawer
                        dateInfo={dateInfo}
                        calendarRef={calendarRef}
                        startDate={startDate}
                        isEdit={isEdit}
                        currentViewDate={currentViewDate}
                        setEdit={setEdit}
                        close={() => {
                            setStep(1);
                            setStep(0); // Show calendar again
                            setDateInfo(null);
                            setEdit(false);
                        }}
                    />
                ) : !isEdit && dateInfo ? (
                    <BookingDrawer
                        dateInfo={dateInfo}
                        calendarRef={calendarRef}
                        currentViewDate={currentViewDate}
                        startDate={startDate}
                        isEdit={isEdit}
                        setEdit={setEdit}
                        close={() => {
                            setStep(1);
                            setStep(0); // Show calendar again
                            setDateInfo(null);
                            setEdit(false);
                        }}
                    />
                ) : (
                    <></>
                )}
            </div>
            <PremiumMessage
                open={premiumAlert}
                handleClose={(e, reason) => handleClosePremium(e, reason)}
                text="Kan kun bruges med pro abonnement"
            />
            <OpeningHours open={openingHour} handleClose={() => setOpeningHour(false)} />
        </>
    );
};

const formatDate = timestamp => {
    return moment(new Date(+timestamp)).format("yyyy-MM-DD HH:mm:ss");
};

const ShowHolidayDialog = ({ open, onClose, data, onDelete }) => {
    return (
        <div>
            <Dialog open={open} onClose={onClose}>
                <DialogTitle>Detaljer</DialogTitle>
                <DialogContent
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 5,
                        minWidth: "400px"
                    }}>
                    <Typography variant="body1" style={{ display: "flex", justifyContent: "space-between" }}>
                        <strong>Dato Oprettet:</strong> {data?.from && format(new Date(+data?.from), "yyyy-MM-dd")}
                    </Typography>
                    <Typography variant="body1" style={{ display: "flex", justifyContent: "space-between" }}>
                        <strong>Fra:</strong> {formatDate(data?.from)}
                    </Typography>
                    <Typography variant="body1" style={{ display: "flex", justifyContent: "space-between" }}>
                        <strong>Til:</strong> {formatDate(data?.to)}
                    </Typography>
                    <Typography
                        variant="body1"
                        style={{
                            wordBreak: "break-word",
                            textJustify: "inter-word"
                        }}>
                        <strong>Årsag:</strong> {data?.reason}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        startIcon={<DeleteIcon />}
                        style={{
                            textTransform: "capitalize"
                        }}
                        onClick={() => {
                            if (!window.confirm("Er du sikker?")) return;
                            API.deleteBooking(data?.id);
                            onDelete();
                            onClose();
                        }}>
                        Slet Booking
                    </Button>

                    <Button onClick={onClose} color="primary">
                        Luk
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
